import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.data ? props.data.title : "Loading"}</h2>
          <p>{props.data ? props.data.paragraph : "Loading"}</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.items.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-3 service-container"
                >
                  {" "}
                  <img
                    src={d.img}
                    alt="..."
                    className="service-img"
                    onMouseOver={(e) =>
                      (e.currentTarget.src = `${d.img.replace(
                        ".png",
                        "-red.png"
                      )}`)
                    }
                    onMouseOut={(e) => (e.currentTarget.src = `${d.img}`)}
                  />
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
